import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import { Loading } from "../state";
import { Formik, Form, Field } from "formik";
import { FormInput } from "../forms/elements";
import { Button, Col, Container, Row } from "react-bootstrap";

var LoyaltyLogInForm = /*#__PURE__*/function (_Component) {
  _inherits(LoyaltyLogInForm, _Component);

  var _super = _createSuper(LoyaltyLogInForm);

  function LoyaltyLogInForm(props) {
    var _this;

    _classCallCheck(this, LoyaltyLogInForm);

    _this = _super.call(this, props);

    _this.onUnload = function (e) {
      _this.setState({
        randomKey: Math.random()
      });
    };

    _this.state = {
      randomKey: Math.random()
    };
    return _this;
  }

  _createClass(LoyaltyLogInForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("beforeunload", this.onUnload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.onUnload);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          errorEmail = _this$props.errorEmail,
          labelEmail = _this$props.labelEmail,
          btnText = _this$props.btnText,
          handleNoUserFound = _this$props.handleNoUserFound;
      return /*#__PURE__*/React.createElement(Container, {
        className: "loyalty--sign-in-form__container",
        key: this.state.randomKey
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Formik, {
        initialValues: {
          email: ""
        },
        validateOnMount: true,
        validate: function validate(values) {
          var errors = {};

          if (!values.email || !/^[A-Z0-9._-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
            errors.email = errorEmail;
          }

          return errors;
        },
        onSubmit: function onSubmit(values, _ref) {
          var setSubmitting = _ref.setSubmitting;
          handleNoUserFound(values.email);
          setSubmitting(false);
        }
      }, function (_ref2) {
        var isSubmitting = _ref2.isSubmitting,
            isValid = _ref2.isValid;
        return /*#__PURE__*/React.createElement(Form, {
          className: "loyalty--sign-in-form"
        }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
          type: "email",
          name: "email",
          className: "cb-form__input--full",
          label: labelEmail,
          component: FormInput
        }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
          type: "submit",
          disabled: isSubmitting || !isValid,
          className: "cb-button-primary loyalty--sign-in-form__submit"
        }, btnText), /*#__PURE__*/React.createElement(Loading, {
          isLoading: isSubmitting
        }))));
      }))));
    }
  }]);

  return LoyaltyLogInForm;
}(Component);

export default LoyaltyLogInForm;